import axios from "utils/axios";
const resource = "options";

export const getPropertyOptions = () => {
  return axios.get(`/${resource}/property`);
};

// [crm-iso] START — hidden feature (lihat CrmIsoSetting/TEARDOWN.md)
export const getOptionByName = (name) => {
  return axios.get(`/${resource}/${name}`);
};
// [crm-iso] END

export const updateOptions = (data) => {
  return axios.put(`/${resource}`, data);
};
